const STEPS = [
  { n: "01", t: "Vous vérifiez votre éligibilité", d: "Trois questions. Trente secondes. Sans engagement." },
  { n: "02", t: "Nous montons le premier dossier", d: "Vous signez. Nous gérons l'intégralité des pièces et du dépôt CARSAT." },
  { n: "03", t: "La CARSAT verse la subvention", d: "Le versement tombe directement sur le compte bancaire de votre entreprise." },
  { n: "04", t: "Nous enchaînons les enveloppes suivantes", d: "Le cadre prévoit plusieurs aides cumulables, déclenchées à votre rythme." },
  { n: "05", t: "À chaque étape, vous décidez", d: "Vous ne payez jamais avant d'avoir encaissé. C'est contractuel à chaque fois." },
];

export default function HowItWorks() {
  return (
    <section className="bg-[var(--pc-bg-soft)] border-y pc-line" aria-label="Méthode en cinq étapes">
      <div className="mx-auto max-w-6xl px-5 lg:px-8 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div id="methode" className="lg:col-span-4" tabIndex={-1}>
            <div className="lg:sticky lg:top-24">
              <div className="flex items-center gap-3 mb-5">
                <span className="tricolor-stripe !h-2.5" aria-hidden />
                <span className="text-[11.5px] tracking-[0.18em] uppercase pc-text-muted font-semibold">Méthode</span>
              </div>
              <h2 className="display-2 pc-text-ink text-balance" data-testid="how-h2">
                Cinq étapes.
                <span className="block pc-text-muted font-serif-emph mt-1">Aucun risque.</span>
              </h2>
              <div className="mt-8 inline-flex items-center gap-2 rounded-full bg-white border pc-line px-4 py-2 text-[13px] font-medium pc-text-ink">
                <span className="w-1.5 h-1.5 rounded-full bg-[var(--pc-blue)]" />
                Engagement contractuel à chaque étape
              </div>
            </div>
          </div>

          <ol className="lg:col-span-8 card-surface bg-white divide-y pc-line">
            {STEPS.map((s, i) => (
              <li
                key={s.n}
                className="p-7 sm:p-8 flex gap-6 sm:gap-8 group transition-colors hover:bg-[var(--pc-bg-soft)] first:rounded-t-[14px] last:rounded-b-[14px]"
                data-testid={`how-step-${i + 1}`}
              >
                <div className="font-serif-num text-[40px] sm:text-[46px] leading-none tracking-[-0.025em] text-[var(--pc-line-strong)] group-hover:pc-text-blue transition-colors font-semibold shrink-0 w-[64px] sm:w-[72px] pt-1">
                  {s.n}
                </div>
                <div className="pt-1.5 flex-1 min-w-0">
                  <h3 className="text-[18.5px] sm:text-[19.5px] pc-text-ink font-semibold tracking-[-0.015em] leading-snug">{s.t}</h3>
                  <p className="pc-text-muted text-[15px] leading-[1.6] mt-2 max-w-md">{s.d}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
